(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CMS", [], factory);
	else if(typeof exports === 'object')
		exports["CMS"] = factory();
	else
		root["CMS"] = factory();
})(self, () => {
return 